import { useCallback } from "react";

import { reconnectAttemptsVar } from "@/stores/knowledgeGraph";

/**
 * Custom hook for managing SSE reconnection attempt tracking
 * @remarks
 * Provides operations to track and reset reconnection attempts for SSE chat connections.
 * Uses Apollo reactive variable for state management.
 * @returns Reconnection operation functions
 */
export const useReconnectOperations = () => {
  /**
   * Increment the reconnection attempts counter
   */
  const incrementReconnectAttempts = useCallback(() => {
    const current = reconnectAttemptsVar();
    reconnectAttemptsVar(current + 1);
  }, []);

  /**
   * Reset reconnection attempts counter to 0
   */
  const resetReconnectAttempts = useCallback(() => {
    reconnectAttemptsVar(0);
  }, []);

  return {
    incrementReconnectAttempts,
    resetReconnectAttempts,
  };
};
